module.exports = __webpack_public_path__ + "assets/media/lunch.3d6402a3.mp3";